import { useQuery } from '@tanstack/react-query';

import { UTBReportData } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const retrieveUTBReportData = async (batchId, page): Promise<UTBReportData> => {
  try {
    const { data } = await request({
      path: `batches/${batchId}/retrieve-utb-report-data`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        page,
      },
    });

    return data;
  } catch (error) {
    showErrorToast(error, 'Error fetching UTB report data!');
  }
};

export const useRetrieveUTBReportData = (batchId: string, page = 0) =>
  useQuery({
    queryKey: ['retrieve-utb-report-data', batchId, page],
    queryFn: async () => retrieveUTBReportData(batchId, page),
    enabled: !!batchId,
  });
